import router from "./router";
import store from "./store";
// import { Message } from 'element-ui'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";

NProgress.configure({ showSpinner: false });
const whiteList = [
  "/login",
  "/index",
  "/organization",
  "/org-details",
  "/policy",
  "/policy-details",
  "/register",
  "/publicity",
  "/publicity-details",
  "/problem",
  "/dataCenter",
  "/problem-detail",
  "/dataCenter-detail"
];

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    if (to.meta.navlist) {
      store.commit("SET_NAVLIST", to.meta.navlist);
    } else {
      store.commit("SET_NAVLIST", []);
    }
    /* has token*/
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      next();
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
      NProgress.done();
      store.dispatch("getNavIndex", "-1");
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});



// WEBPACK FOOTER //
// ./src/permission.js